<template>
    <div>Kasa</div>
</template>

<script>
    export default {
        name: "kasa"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/_/kasa.vue